export default [
  {
    text: "productRequest.state.REQUESTED",
    value: "REQUESTED",
  },
  {
    text: "productRequest.state.APPROVED",
    value: "APPROVED",
  },
  {
    text: "productRequest.state.REJECTED",
    value: "REJECTED",
  },
];
